<template>
  <section class="section center">
    <div class="card">
      <h1>Checkout cancelled</h1>
      <RouterLink class="button" to="/pricing">Back to pricing</RouterLink>
    </div>
  </section>
</template>
